import React, { Component } from 'react';
import '../../node_modules/font-awesome/css/font-awesome.min.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style.css';
import { Link } from 'react-router-dom';
import Header from './Header';
import card1 from '../assets/images/future-collections/card1.png';
import card2 from '../assets/images/future-collections/card2.png';
import card3 from '../assets/images/future-collections/card3.png';
import card4 from '../assets/images/future-collections/card4.png';
import card5 from '../assets/images/future-collections/card5.png';
import card6 from '../assets/images/future-collections/card6.png';
import artistPic from '../assets/images/future-collections/profile-picture.png';

class FutureCollection extends Component {
    render() {
        return (
            <div className="main-wrapper">
                {/* Header area start */}
                <Header />
                {/* Header area end */}

                {/* Hero slider start */}
                <div className="container-fluid">
                    <Link to="/Collection">
                        <div className="row future-header justify-content-center">
                            <div className="header-text col-lg-7 col-sm-12">
                            </div>
                            <div className="col-lg-4 col-sm-10 artist text-center">
                                <span>Okuda San Miguel</span>
                                <h6>Digital Trip</h6>
                            </div>
                        </div>
                    </Link>
                </div>
                {/* Hero slider end */}

                {/* Collection content area start */}
                <div className="container margin-70 text-center collection-content">
                    <div className="row justify-content-center">
                        <div className="col-md-10 text-center">
                            <h3>Okuda releases debut NG collection!</h3>
                            <p>Known for his vibrant, large-scale artworks, which include murals, sculptures, and immersive installations, the Madrid-based artist is now making his first foray into digital art, with a collection that includes five original pieces, is entirely carbon-neutral, and a portion of sales will be donated to the Coloring the World Foundation.</p>
                            <p>This series will be the first of several limited edition NFT drops by Okuda!</p>
                        </div>
                    </div>
                    {/* Closed COllection cards area start */}
                    <h1>Collection opens in 5hours 12 minutues and 27 seconds</h1>
                    <div className="closed-collection text-left justify-content-center row">
                        <div className="card">
                            <div className="closed-collection-card">
                                <Link to="/FutureCollectionDetails">
                                    <img src={card1} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/FutureCollectionDetails">
                                        <h3>Kaleidoscopic Journey</h3>
                                    </Link>
                                    <p>MINIMUM BID&emsp;<strong>$1,499.00</strong></p>
                                    <p className="card-text">1 Edition</p>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="closed-collection-card">
                                <Link to="/FutureCollectionDetails">
                                    <img src={card2} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/FutureCollectionDetails">
                                        <h3>Kaleidoscopic Skulls</h3>
                                    </Link>
                                    <p>MINIMUM BID&emsp;<strong>$1,499.00</strong></p>
                                    <p className="card-text">5 Edition</p>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="closed-collection-card">
                                <Link to="/FutureCollectionDetails">
                                    <img src={card3} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/FutureCollectionDetails">
                                        <h3>Kaleidoscopic Animals</h3>
                                    </Link>
                                    <p>--</p>
                                    <p className="card-text">5 Edition</p>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="closed-collection-card">
                                <Link to="/FutureCollectionDetails">
                                    <img src={card4} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/FutureCollectionDetails">
                                        <h3>Universe Walk</h3>
                                    </Link>
                                    <p>MINIMUM BID&emsp;<strong>$1,499.00</strong></p>
                                    <p className="card-text">1 Edition</p>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="closed-collection-card">
                                <Link to="/FutureCollectionDetails">
                                    <img src={card5} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/FutureCollectionDetails">
                                        <h3>Skull House</h3>
                                    </Link>
                                    <p>$1.11</p>
                                    <p className="card-text">55 Editions</p>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="closed-collection-card">
                                <Link to="/FutureCollectionDetails">
                                    <img src={card6} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/FutureCollectionDetails">
                                        <h3>Skull House – Grey Edition</h3>
                                    </Link>
                                    <p>$1</p>
                                    <p className="card-text">3 Edition</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Closed COllection cards area end */}

                    {/* Why love arae start */}
                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <h3>Why we love Okuda San Miguel</h3>
                            <Link to="/UserProfileArtist"><img src={artistPic} alt="artistPic" className="collection-artist-pic" /></Link>
                            <p>We are incredibly excited to welcome Okuda to Nifty Gateway for his debut release! His collection features multiple colorful and vibrant artworks. Each piece has a unique release format so anyone can get involved!</p>
                            <h3>Follow Okuda San Miguel to receive exclusive release info</h3>
                            <button>Follow</button>
                            <h3>Learn More about Okuda San Miguel</h3>
                            <h6><Link to="#">https://website.com</Link></h6>
                            <h6><Link to="#">https://socialmedia.com</Link></h6>
                        </div>

                    </div>
                    {/* Why love arae end */}
                </div>
                {/* Collection content area end */}
            </div >
        )
    }
};

export default FutureCollection;